<template>
    <nav>
        <ul class="pagination pagination-sm">
            <li v-for="page in pages" :class="{'page-item': true, 'active': page.isActive}">
                <span v-if="page.isActive" class="page-link">{{ page.idx }}</span>
                <a v-else class="page-link" @click="onPageChange(page)">{{ page.idx }}</a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ['total', 'itemsPerPage', 'currentPage'],
    data: function () {
        return {};
    },
    computed: {
        pages() {
            const ret = [];
            const lastPage = Math.ceil(this.total / this.itemsPerPage);
            for(let i = 1; i <= lastPage; i++) {
                ret.push({
                    idx: i,
                    isActive: i === this.currentPage,
                });
            }
            return ret;
        },
    },
    mounted() {
    },
    methods: {
        onPageChange(page) {
            this.$emit('on-page-change', page.idx);
        },
    }
}
</script>
